import { render, staticRenderFns } from "./DashboardNotificationBar.vue?vue&type=template&id=470e0bbf"
import script from "./DashboardNotificationBar.vue?vue&type=script&lang=js"
export * from "./DashboardNotificationBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports